import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { NavbarButton } from './navbar-button/navbar-button';
import { ButtonModule } from 'primeng/button';
import {
  LucideChartPie,
  LucideCircleUser,
  LucideGoal,
  LucideGraduationCap,
  LucideLogOut,
  LucideMessageCircleMore,
} from '@lucide/angular';
import { UserRole } from '@app/core/models/user-role';
import { AuthService } from '@app/core/services/auth.service';

@Component({
  selector: 'app-navbar',
  imports: [ButtonModule, NgOptimizedImage, NavbarButton],
  templateUrl: './navbar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Navbar {
  readonly #authService = inject(AuthService);

  logout() {
    this.#authService.logout();
  }

  protected readonly icons = {
    logOut: LucideLogOut,
    messageCircle: LucideMessageCircleMore,
    graduationCap: LucideGraduationCap,
    chartPie: LucideChartPie,
    goal: LucideGoal,
    circleUser: LucideCircleUser,
  } as const;
  protected readonly UserRole = UserRole;
}
